import { Footer as FooterContainer } from "../../NetworkPage/styles";
import LinkedinLogo from "./linkedin.png";
import {
  Copyright,
  Link,
  LinkList,
  LinkListTitle,
  LogoContainerFooter,
  SocialImage,
  LinkListsContainer,
} from "./styles";
import TwitterLogo from "./twitter.png";

import * as Logos from "~/components/icons/Logo";

const productLinks = [
  { name: "TRAVEL RULE CRYPTO", link: "https://notabene.id/product-travel-rule" },
  { name: "CRYPTO WALLET ID", link: "https://notabene.id/wallet-identification" },
  { name: "VASP NETWORK", link: "https://app.notabene.id/network" },
  { name: "DEVELOPERS", link: "https://doc.notabene.id/" },
  { name: "REGULATIONS", link: "https://notabene.id/regulations" },
];

const companyLinks = [
  { name: "ABOUT", link: "https://notabene.id/about-us" },
  { name: "BLOG", link: "https://notabene.id/blog" },
  { name: "JOBS", link: "https://notabene.id/jobs" },
  { name: "TERMS OF SERVICE", link: "https://notabene.id/terms-of-services" },
  { name: "PRIVACY POLICY", link: "https://notabene.id/privacy-policy" },
  {
    name: "VULNERABILITY DISCLOSURE POLICY",
    link: "https://www.notion.so/notaben/Vulnerability-Disclosure-Policy-2bd9d16839914cc1a48407da199727a6",
  },
];

export default function Footer() {
  return (
    <FooterContainer>
      <LinkListsContainer>
        <LinkList>
          <LinkListTitle>PRODUCT</LinkListTitle>
          {productLinks.map((link) => (
            <Link key={link.link} href={link.link} rel="noreferrer" target="_blank">
              {link.name}
            </Link>
          ))}
        </LinkList>
        <LinkList>
          <LinkListTitle>COMPANY</LinkListTitle>
          {companyLinks.map((link) => (
            <Link key={link.link} href={link.link} rel="noreferrer" target="_blank">
              {link.name}
            </Link>
          ))}
        </LinkList>
      </LinkListsContainer>

      <LogoContainerFooter>
        <img src="/assets/SOC-certificate.png" alt="SOC-certificate logo" />
      </LogoContainerFooter>

      <LogoContainerFooter inverted={true}>
        <Logos.Logo style={{ width: "100%", height: "100%" }} />
      </LogoContainerFooter>
      <Copyright>Copyright © 2022 Notabene, Inc. All rights reserved.</Copyright>
      <div>
        <a rel="noreferrer" target="_blank" href="https://twitter.com/notabene_id">
          <SocialImage src={TwitterLogo.src} />
        </a>
        <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/company/notabene-id">
          <SocialImage src={LinkedinLogo.src} />
        </a>
      </div>
    </FooterContainer>
  );
}
